import json from "@/data/copy/idle-tab.json";
import { createCopyGetter } from "@/lib/localize-copy";
import { formatCopy } from "@/lib/copy-format";
import { parseLocaleFromPathname, resolveMarketingRoute } from "@/lib/i18n/paths";
import type { Lang } from "@/lib/types";

export const getIdleTabCopy = createCopyGetter(json);
export const IDLE_TAB_DELAY_MS = json.delayMs;

/** Route identity and localized slug aliases stay in the canonical route loaders. */
export function getIdleTabMessage(pathname: string, lang: Lang): string {
  const copy = getIdleTabCopy(lang);
  const { locale, pathWithoutLocale } = parseLocaleFromPathname(pathname);
  const route = resolveMarketingRoute(pathWithoutLocale, locale ?? "en");
  if (route?.kind !== "service" && route?.kind !== "service-subpage") return copy.defaultMessage;

  const services = copy.services as Record<string, { topic: string; subpages: Record<string, string> }>;
  const service = services[route.serviceTag];
  const topic = route.kind === "service-subpage"
    ? service?.subpages[route.subKey] ?? service?.topic
    : service?.topic;
  return topic ? formatCopy(copy.topicMessage, { topic }) : copy.defaultMessage;
}
